const isGoal = (card: CanvasCard.Card): card is CanvasCard.GeneralGoalCard =>
  card.content.type === 'Goal';

export default isGoal;
